module.exports = __webpack_public_path__ + "media/images/selectionBet__decoPickWinner-8e44f2d31bbaabdd30fb64679357cf20.png";